import { useSyncExternalStore } from 'react';

import { Button } from '@mui/material';
import { Stack } from '@mui/system';
import { RouteLink, useTranslation } from '@scorenco/core';

import { T_KEYS } from '../../../translations';

const subscribe = () => {
  return () => {
    return;
  };
};

const getAuthenticatedServerSnapshot = () => false;

const getAuthenticatedSnapshot = () => {
  return document.cookie.includes('snc-status=connected');
};

const getCurrentUrlServerSnapshot = () => '';

const getCurrentUrlSnapshot = () => {
  return window.location.href;
};

export const AuthMenu = () => {
  const { t } = useTranslation();

  const authenticated = useSyncExternalStore(
    subscribe,
    getAuthenticatedSnapshot,
    getAuthenticatedServerSnapshot
  );
  const currentUrl = useSyncExternalStore(
    subscribe,
    getCurrentUrlSnapshot,
    getCurrentUrlServerSnapshot
  );
  const redirectParam = currentUrl
    ? `redirectTo=${encodeURIComponent(currentUrl)}`
    : null;

  if (authenticated) {
    return (
      <Button
        component={RouteLink}
        href={process.env.NEXT_PUBLIC_MOBILE_URL}
        color="secondary"
        variant="contained"
      >
        Tableau de bord
      </Button>
    );
  }

  return (
    <Stack gap={2} direction="row" justifyContent="center" alignItems="center">
      <Button
        component={RouteLink}
        href={[
          `${process.env.NEXT_PUBLIC_MOBILE_URL}/auth/select-sport`,
          redirectParam,
        ]
          .filter(Boolean)
          .join('?')}
        color="secondary"
        variant="contained"
      >
        {t(T_KEYS.AUTHENTIFICATION_SIGN_UP)}
      </Button>
      <Button
        component={RouteLink}
        href={[
          `${process.env.NEXT_PUBLIC_MOBILE_URL}/auth/sign-in`,
          redirectParam,
        ]
          .filter(Boolean)
          .join('?')}
        color="secondary"
        variant="outlined"
      >
        {t(T_KEYS.AUTHENTIFICATION_SIGN_IN)}
      </Button>
    </Stack>
  );
};
